'use client';

import { useState } from "react";
import { Button } from '@/components/ui/button';
import { PDFViewerProps } from './pdf-viewer.types'
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Document, Page , pdfjs} from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf-worker.mjs';

const PDFViewer = ({ width, height, documentUrl }: PDFViewerProps) => {
  const [numPages, setNumPages] = useState<number>(1);
  const [pageNumber, setPageNumber] = useState<number>(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const onDocumentLoadError = (error: Error) => {
    console.info('Error loading document', error);
  }

  const nextPage = () => {
    if(pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  }

  const prevPage = () => {
    if(pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  }

  return (
    <div className={'relative'}>
      <div className={'border border-gray-300 '}>
          <Document className={'w-full'} file={documentUrl} onLoadSuccess={onDocumentLoadSuccess} onLoadError={onDocumentLoadError} loading={() => {
            return <></>
          }}>
              <Page className={'w-fit'} width={width ? width-2 : 400} height={height ? height-2 : 600} pageNumber={pageNumber} />
          </Document>
      </div>
        {numPages > 2 ? 
            <div className="flex flex-row items-center justify-center gap-2 p-2 ">
              <Button className='border-none flex-grow outline-none bg-transparent text-gray-500 hover:text-black hover:bg-transparent' onClick={() => prevPage()}><ArrowLeft /></Button> 
              <span className='text-sm'>Page {pageNumber} of {numPages} </span>
              <Button className='border-none flex-grow outline-none bg-transparent text-gray-500 hover:text-black hover:bg-transparent  ' onClick={() => nextPage()}><ArrowRight /></Button>
            </div>
        : null}
    </div>
  );
}

export { PDFViewer }